import { useEffect } from "react";
import ReactDOM from "react-dom";
import MonthPicker from "src/components/common/calendar/MonthPicker";
import { gridCalendarLayoutHeight, gridCalendarWidth } from "src/components/common/common";

interface Props {
	rowIndex: number;
	targetField: string;
	visible: boolean;
	setVisible: (visible: boolean) => void;
    value?: Date;
	onClear: () => void;
    onChange: (date: Date | undefined, rowIndex: number, targetField: string) => void;
	onClickLoad: (rowIndex: number, targetField: string) => void;
	pickerPosition: { top: number; left: number };
}

export const GridMonthCalendar = ( props: Props ) => {
    const { 
		rowIndex,
		targetField,
		visible, setVisible,
		value, 
		onClear,
		onChange,
		onClickLoad,
		pickerPosition,
	} = props;

	useEffect(() => {
		if(visible) {
			onClickLoad(rowIndex, targetField);
		}
	}, [visible, rowIndex, targetField, onClickLoad]);

    return (
		<>
			{visible &&
				ReactDOM.createPortal(
				<>
				<div
					style={{
						position: 'fixed',
						top: 0,
						left: 0,
						width: gridCalendarWidth,
						height: gridCalendarLayoutHeight,
						zIndex: 10000,
					}}
					onClick={ () => {
						if(visible) setVisible(false);
					}}
					/>
					<div style={{
								position: 'absolute',
								top: `${pickerPosition.top}px`,
								left: `${pickerPosition.left}px`,
								zIndex: 10001,
							}}
							onClick={(e) => e.stopPropagation()}
						>
						<MonthPicker
							value={value}
							onClear={() => {
								onClear();
								setVisible(false);
							}}
							onChange={(date) => {
								onChange(date, rowIndex, targetField);
							}}
							onReset={() => {
								const today = new Date();
								onChange(new Date(today.getFullYear(), today.getMonth(), 1), rowIndex, targetField);
								setVisible(false);
							}}
							onConfirm={(date) => {
								onChange(date, rowIndex, targetField);
								setVisible(false);
							}}
						/>
					</div>
				</>
				, document.body)
			}
		</>
	)
}